import {createEventBus} from "../common";

export interface IRouteChanged{
  routePath: string; // The React Router route (e.g. "/lesson/:id?/:segmentId?/:mode?").
  locationPath: string; // The equivalent of window.location.pathname (after the hash # symbol for HashRouter).
  search: string | undefined; // The query string (after the hash # symbol for HashRouter).
  userHasValidToken: boolean;
}

export const {subscribe: subscribeToRouteChanged, emitMessage: routeChanged} = createEventBus<IRouteChanged>();